import tickets from './tickets.json';

export default { ...tickets };
